var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
          fill: "#4868FD"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12.2055 10.7657C14.118 10.7657 15.6684 9.21531 15.6684 7.30282C15.6684 5.39034 14.118 3.83997 12.2055 3.83997C10.293 3.83997 8.74268 5.39034 8.74268 7.30282C8.74268 9.21531 10.293 10.7657 12.2055 10.7657Z",
          fill: "#FFE252"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M19.9886 20.3658H4.25146V19.0972C4.25146 15.2229 7.37146 12.1029 11.2458 12.1029H12.9943C16.8686 12.1029 19.9886 15.2229 19.9886 19.0972V20.3658Z",
          fill: "#FFE252"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16.6288 14.2971C16.663 14.2628 16.6973 14.2628 16.6973 14.2285C16.903 14.0914 17.3145 13.7143 17.3488 13.6114C17.1203 13.433 16.7413 13.1651 16.448 13.0085C16.0022 13.4199 15.8745 13.44 15.5659 13.7828C15.463 13.92 15.2916 13.92 15.0173 14.1257C14.9488 14.16 14.8802 14.2285 14.7773 14.2628C14.8459 14.1943 14.6059 14.2971 14.7088 14.2285C14.2973 14.5028 14.4345 14.4343 13.9888 14.6057C13.1316 14.5371 13.7145 14.88 12.6516 14.7771C12.6859 14.7771 12.6859 14.7771 12.7202 14.7771C12.4802 14.7771 11.7945 14.88 12.4116 14.8457C11.9659 14.9828 11.3488 14.8114 12.2745 14.8114C12.1716 14.7771 11.9316 14.8457 12.0345 14.7771C11.9316 14.8457 11.1431 14.7428 11.4516 14.7085C11.2802 14.7085 11.1088 14.64 10.9373 14.6057C11.2802 14.6743 11.0059 14.6743 11.143 14.7085C10.6973 14.6743 10.903 14.5714 10.423 14.4685C11.0402 14.6743 9.25733 14.16 9.63448 14.1943C9.01733 13.8857 9.05162 13.92 8.81162 13.68C8.74305 13.6457 8.40019 13.44 8.57162 13.5085C8.46876 13.4743 8.26305 13.3028 8.57162 13.44C8.46876 13.3714 8.00848 13.0058 7.95796 12.9137C7.95796 12.9137 7.58055 13.0995 7.44394 13.1919C7.30733 13.2843 6.95947 13.5615 6.95947 13.5615C7.09662 13.8701 7.95448 14.3657 7.64591 14.3314C7.81733 14.3314 8.46876 14.6743 7.98876 14.6057C8.05733 14.64 8.12591 14.7085 8.26305 14.8114C8.16019 14.5714 8.40019 14.8457 8.53733 14.9828C8.43448 14.88 8.84591 14.9485 8.60591 15.0171C8.70876 15.0514 8.81162 15.0857 8.91448 15.0857C8.84591 15.0514 8.88019 15.1543 8.91448 15.1885C8.88019 15.1543 9.15448 15.2914 9.22305 15.3257L9.12019 15.2571C9.70305 15.4628 9.80591 15.4971 10.4573 15.6343C9.77162 15.6343 10.2173 15.7371 10.0459 15.7371C10.6973 15.84 11.5888 15.9428 12.3773 15.9428C12.8573 15.9085 13.5773 15.6685 14.023 15.7028C14.0573 15.6685 14.0916 15.6685 14.1945 15.6343C14.1602 15.5657 16.0459 14.9828 16.6288 14.2971Z",
          fill: "#02016F"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }